<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="1.1rem" height="1.1rem" viewBox="0 0 23.039 31.5">
        <g id="asiento-de-coche" transform="translate(-17.202 -0.013)">
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="2.053" cy="2.053" r="2.053" transform="translate(20.783 24.059) rotate(-13.3)"/>
            <path id="Path_1" data-name="Path 1" d="M23.249,23.053a2.466,2.466,0,0,1,2.218,1.3,3.144,3.144,0,0,0,1.14-2.3,5.021,5.021,0,0,0-.763-2.909,24.713,24.713,0,0,1-1.568-2.891A22.079,22.079,0,0,1,22.6,10.929c-.059-.325-.123-.638-.192-.933a2.32,2.32,0,0,0-2.262-1.807c-.106,0-.2.01-.305.02l-.039,0a2.759,2.759,0,0,0-.3.065V7.271A2.268,2.268,0,0,0,21.714,5.3l.361-2.733a2.266,2.266,0,1,0-4.492-.594l-.362,2.735a2.267,2.267,0,0,0,1.785,2.513V8.461A2.694,2.694,0,0,0,17.6,11.7l3.754,12.2a2.508,2.508,0,0,1,1.892-.845Z" transform="translate(0 0)"/>
            <path id="Path_2" data-name="Path 2" d="M57.956,91.89a2.784,2.784,0,0,0-1.1-1.9,2.841,2.841,0,0,0-2.129-.571L44.548,90.775a3.461,3.461,0,0,1-1.11,1.428,2.466,2.466,0,0,1,.123.773,2.549,2.549,0,0,1-2.545,2.546c-.084,0-.165,0-.246-.012v1.044H56.12S58.372,95.592,57.956,91.89Z" transform="translate(-17.767 -67.377)"/>
            <path id="Path_3" data-name="Path 3" d="M40.77,120.442v.342a1.505,1.505,0,0,0,1.5,1.5H54.79a1.5,1.5,0,0,0,1.5-1.5v-.357l-.022.015Z" transform="translate(-17.767 -90.775)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "SeatIcon"
}
</script>

<style scoped>

</style>
